import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["YouTube Ads", "YouTube Organic", "youTube", "YT Partnerships"],
  iconColor: "#F05F33", // mars
  getIcon(options) {
    return createIcon(
      `
      <path
        d="M17.7528 8.40827C17.6144 7.85761 17.2091 7.42356 16.6951 7.27528C15.7561 7 11.9999 7 11.9999 7C11.9999 7 8.24376 7 7.30471 7.26479C6.80063 7.41297 6.38544 7.85771 6.2471 8.40827C6 9.41407 6 11.5 6 11.5C6 11.5 6 13.5964 6.2471 14.5917C6.38553 15.1423 6.79074 15.5764 7.3048 15.7247C8.25365 16 12 16 12 16C12 16 15.7561 16 16.6951 15.7352C17.2092 15.587 17.6144 15.1529 17.7528 14.6023C17.9999 13.5964 17.9999 11.5106 17.9999 11.5106C17.9999 11.5106 18.0098 9.41407 17.7528 8.40827Z"
        fill="#FF0000"
      />
      <path
        d="M10.804 13.4274L13.9274 11.5003L10.804 9.57324V13.4274Z"
        fill="white"
      />
      `,
      "#FDEFEB", // mars-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
